// extracted by css-extract-rspack-plugin
export default {"root":"root-svFXUI","compact":"compact-FlKE_f"};